import { defineStore } from 'pinia';
import { useMapStoreData } from '@/stores/data';

//narava icons
import icon80 from '@/assets/categories-icons/narava.svg';
import icon84 from '@/assets/categories-icons/narava-voda.svg';
import icon85 from '@/assets/categories-icons/narava-gozd.svg';
import icon86 from '@/assets/categories-icons/narava-zeleno.svg';
import icon104 from '@/assets/categories-icons/narava-gore.svg';
//sport icons
import icon81 from '@/assets/categories-icons/sport.svg';
import icon87 from '@/assets/categories-icons/sport-kolo.svg';
import icon88 from '@/assets/categories-icons/sport-pohodnistvo.svg';
import icon89 from '@/assets/categories-icons/sport-ostale.svg';
import icon99 from '@/assets/categories-icons/sport-druzinske-aktivnosti.svg';
//kultura icons
import icon82 from '@/assets/categories-icons/kultura.svg';
import icon90 from '@/assets/categories-icons/kultura-kulturne-ustanove.svg';
import icon91 from '@/assets/categories-icons/kultura-spomeniki.svg';
import icon92 from '@/assets/categories-icons/kultura-prireditve.svg';
import icon98 from '@/assets/categories-icons/kultura-sakralni-objekti.svg';
import icon100 from '@/assets/categories-icons/kultura-zgodovinske-ustanove.svg';
//turizem icons
import icon83 from '@/assets/categories-icons/turizem.svg';
import icon93 from '@/assets/categories-icons/turizem-hrana.svg';
import icon94 from '@/assets/categories-icons/turizem-prenocisce.svg';
import icon95 from '@/assets/categories-icons/turizem-zabava.svg';
import icon101 from '@/assets/categories-icons/turizem-trgovina.svg';
import icon102 from '@/assets/categories-icons/turizem-info-tocka.svg';
import icon103 from '@/assets/categories-icons/turizem-ostalo.svg';

interface PoiCategory {
	name: string;
	isParent: boolean;
	parentId?: string;
	icon: string;
	cssColor?: string;
	className?: string;
	number: number;
}

export const useCategoriesStore = defineStore('categoriesStore', {
	state: () => ({
		categoryHierarchy: new Map() as Map<string, Array<string>>,
		poiCategories: new Map() as Map<string, PoiCategory>,
		defaultActiveFiltersParentsId: [] as Array<any>,
		activeFilters: [] as Array<string>,
		selectedFilters: [] as Array<string>,
		translator: '' as any,
		maxFilters: 0,
	}),
	actions: {
		setCssColors() {
			console.log('set css colors');

			const natureColor = 'linear-gradient(180deg, #58BBAD 0%, #4BA9AF 100%)';
			const cultureColor = 'linear-gradient(180deg, #E8BD55 0%, #D3A140 100%)';
			const sportColor = 'linear-gradient(180deg, #E26E69 0%, #CF5651 100%)';
			const turismColor = 'linear-gradient(180deg, #60729F 0%, #4B5D8A 100%)';

			const natureColorStart = '#58BBAD';
			const natureColorEnd = '#4BA9AF';

			const cultureColorStart = '#E8BD55';
			const cultureColorEnd = '#D3A140';

			const sportColorStart = '#E26E69';
			const sportColorEnd = '#CF5651';

			const turismColorStart = '#60729F';
			const turismColorEnd = '#4B5D8A';

			const natureColorActive = '#2A873E';
			const cultureColorActive = '#9E882F';
			const sportColorActive = '#992E2E';
			const turismColorActive = '#153945';

			document.documentElement.style.setProperty('--nature-color-gradient', natureColor);
			document.documentElement.style.setProperty('--culture-color-gradient', cultureColor);
			document.documentElement.style.setProperty('--sport-color-gradient', sportColor);
			document.documentElement.style.setProperty('--turism-color-gradient', turismColor);

			document.documentElement.style.setProperty('--nature-color-start', natureColorStart);
			document.documentElement.style.setProperty('--nature-color-stop', natureColorEnd);

			document.documentElement.style.setProperty('--culture-color-start', cultureColorStart);
			document.documentElement.style.setProperty('--culture-color-stop', cultureColorEnd);

			document.documentElement.style.setProperty('--sport-color-start', sportColorStart);
			document.documentElement.style.setProperty('--sport-color-stop', sportColorEnd);

			document.documentElement.style.setProperty('--turism-color-start', turismColorStart);
			document.documentElement.style.setProperty('--turism-color-stop', turismColorEnd);

			document.documentElement.style.setProperty('--nature-color-active', natureColorActive);
			document.documentElement.style.setProperty('--culture-color-active', cultureColorActive);
			document.documentElement.style.setProperty('--sport-color-active', sportColorActive);
			document.documentElement.style.setProperty('--turism-color-active', turismColorActive);
		},
		setCategories() {
			const storeData = useMapStoreData();
			const options = storeData.options;
			const selectorsCategories: any = storeData.dataSelectors;

			// Reset defaultActiveFiltersParentsId array
			this.defaultActiveFiltersParentsId = [];

			if (options != null) {
				// Read hiddenMainCategories option and convert to defaultActiveFiltersParentsId
				if (
					options.options &&
					options.options.hiddenMainCategories &&
					Array.isArray(options.options.hiddenMainCategories)
				) {
					// Get all main category IDs (80, 81, 82, 83)
					const allMainCategories = ['80', '81', '82', '83'];
					// Filter out the hidden categories to get active ones
					this.defaultActiveFiltersParentsId = allMainCategories.filter(
						(catId) => !options.options.hiddenMainCategories.includes(catId)
					);
				} else if (options.options && options.options.defaultActiveFiltersParentsId) {
					// Fallback to old defaultActiveFiltersParentsId option
					this.defaultActiveFiltersParentsId = options.options.defaultActiveFiltersParentsId;
				}

				let categories_set = options.options.categories_set;

				if (categories_set == undefined) {
					categories_set = 666;
				}
				if (typeof categories_set == 'string') {
					categories_set = parseInt(categories_set);
				}

				switch (categories_set) {
					case 665:
						/*this.poiCategories.set('107',{});
                  this.poiCategories.set('108',{});
                  this.poiCategories.set('112',{});
                  this.poiCategories.set('114',{});
                  this.poiCategories.set('117',{});
                  this.poiCategories.set('118',{});
                  this.poiCategories.set('119',{});
                  this.poiCategories.set('121',{});
                  this.poiCategories.set('122',{});*/
						break;
					case 666:
						if (selectorsCategories != null) {
							const categoryIcons = {
								'80': icon80,
								'84': icon84,
								'85': icon85,
								'86': icon86,
								'104': icon104,
								'81': icon81,
								'87': icon87,
								'88': icon88,
								'89': icon89,
								'99': icon99,
								'82': icon82,
								'90': icon90,
								'91': icon91,
								'92': icon92,
								'98': icon98,
								'100': icon100,
								'83': icon83,
								'93': icon93,
								'94': icon94,
								'95': icon95,
								'101': icon101,
								'102': icon102,
								'103': icon103,
							};

							Object.values(selectorsCategories.categories).forEach((category: any) => {
								let isParent = false;
								let color = '';

								if (category.parent == '0') {
									isParent = true;
								}

								switch (category.id) {
									case '80':
									case '84':
									case '85':
									case '86':
									case '104':
										color = '--nature-color';
										break;
									case '81':
									case '87':
									case '88':
									case '89':
									case '99':
										color = '--sport-color';
										break;
									case '82':
									case '90':
									case '91':
									case '92':
									case '98':
									case '100':
									case '103':
										color = '--culture-color';
										break;
									case '83':
									case '93':
									case '94':
									case '95':
									case '101':
									case '102':
										color = '--turism-color';
										break;
								}

								this.poiCategories.set(category.id, {
									name: category.name,
									isParent: isParent,
									parentId: category.parent,
									cssColor: color,
									className: category.id + '-subcategories',
									number: 0,
									icon: categoryIcons[category.id as keyof typeof categoryIcons] ?? icon80,
								});
							});
						}

						selectorsCategories.categories.forEach((category: { id: string; parent: string }) => {
							if (category.parent !== '0') {
								// If the parent is not in the hierarchy yet, add an empty array
								if (!this.categoryHierarchy.has(category.parent)) {
									this.categoryHierarchy.set(category.parent, []);
								}

								// Push the current category's ID to its parent's list
								const parent = this.categoryHierarchy.get(category.parent);
								if (parent) {
									parent.push(category.id);
								}
							}
						});
						/*for (let category of this.poiCategories) {
                    if(category[1].parentId != '0') {
                        this.activeFilters.push(category[0]);
                    }
                  }*/
						break;
					case 667:
						this.categoryHierarchy.set('126', []);
						this.categoryHierarchy.set('127', []);
						this.categoryHierarchy.set('128', []);
						this.categoryHierarchy.set('129', []);

						this.poiCategories.set('126', {
							name: 'pomorska-bastina',
							isParent: true,
							number: 0,
							className: 'pomorska-bastina',
							icon: '<svg class="icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#145A70"/><path d="M43.0733 33.1182C43.0895 32.8082 43.0895 32.4976 43.0733 32.1876V31.9591C42.3386 23.3713 33.9468 16.2693 31.057 13.9999C30.7744 13.7879 30.4307 13.6733 30.0774 13.6733C29.7241 13.6733 29.3804 13.7879 29.0978 13.9999C26.1427 16.2693 17.7509 23.3713 16.9509 31.9591V32.1876C16.9347 32.4976 16.9347 32.8082 16.9509 33.1182V33.3142C16.9509 36.7782 18.327 40.1004 20.7764 42.5498C23.2259 44.9993 26.548 46.3754 30.0121 46.3754C33.4761 46.3754 36.7983 44.9993 39.2478 42.5498C41.6972 40.1004 43.0733 36.7782 43.0733 33.3142V33.1182ZM30.0121 43.1101C29.5791 43.1101 29.1638 42.9381 28.8576 42.6319C28.5515 42.3257 28.3794 41.9104 28.3794 41.4774C28.3794 41.0444 28.5515 40.6291 28.8576 40.323C29.1638 40.0168 29.5791 39.8448 30.0121 39.8448C31.7441 39.8448 33.4052 39.1567 34.6299 37.932C35.8547 36.7073 36.5427 35.0462 36.5427 33.3142C36.5427 32.8811 36.7147 32.4659 37.0209 32.1597C37.3271 31.8535 37.7424 31.6815 38.1754 31.6815C38.6084 31.6815 39.0236 31.8535 39.3298 32.1597C39.636 32.4659 39.808 32.8811 39.808 33.3142C39.808 35.9122 38.7759 38.4038 36.9389 40.2409C35.1018 42.078 32.6101 43.1101 30.0121 43.1101Z" fill="white"/></svg>',
						});
						this.poiCategories.set('127', {
							name: 'spilja',
							number: 0,
							isParent: true,
							className: 'spilja',
							icon: '<svg class="icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#153945"/><path fill-rule="evenodd" clip-rule="evenodd" d="M30.4955 14C24.1635 14 18.7749 18.612 17.7974 24.8681L15.0366 42.5369C14.7523 44.3563 16.1592 46 18.0007 46H42.9904C44.8319 46 46.2387 44.3563 45.9544 42.5369L43.1937 24.8681C42.2161 18.612 36.8276 14 30.4955 14ZM22.9527 27.7239C22.5734 26.7545 21.1499 26.9376 21.0283 27.9714L20.2839 34.299C19.8642 37.8659 22.6512 41 26.2428 41H29.3683C30.095 41 30.7969 40.7362 31.3438 40.2577L33.9903 37.9421C34.2959 37.6747 34.7328 37.6186 35.096 37.8002L38.1819 39.3432C39.6048 40.0546 41.2485 38.9006 41.0626 37.3207L39.7366 26.0494C39.639 25.2196 38.6272 24.8684 38.0364 25.4591L35.7965 27.699C35.3712 28.1243 34.6693 28.0806 34.3001 27.6058L32.4889 25.2772C32.0325 24.6904 31.1181 24.7891 30.7974 25.4597L26.9894 33.4218C26.612 34.2109 25.4748 34.1693 25.1561 33.3547L22.9527 27.7239Z" fill="white"/></svg>',
						});
						this.poiCategories.set('128', {
							name: 'arheoloska-bastina',
							isParent: true,
							number: 0,
							className: 'arheoloska-bastina',
							icon: '<svg class="icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#E0B710"/><path d="M25.1024 16.9386H34.8983C35.3313 16.9386 35.7466 16.7666 36.0528 16.4605C36.3589 16.1543 36.531 15.739 36.531 15.306C36.531 14.873 36.3589 14.4577 36.0528 14.1515C35.7466 13.8454 35.3313 13.6733 34.8983 13.6733H25.1024C24.6694 13.6733 24.2541 13.8454 23.9479 14.1515C23.6417 14.4577 23.4697 14.873 23.4697 15.306C23.4697 15.739 23.6417 16.1543 23.9479 16.4605C24.2541 16.7666 24.6694 16.9386 25.1024 16.9386Z" fill="white"/><path d="M38.9796 25.1021C38.2364 25.1198 37.4974 25.2184 36.7755 25.3959C36.2627 24.6526 35.6279 24.0012 34.898 23.4694V20.2041H25.1021V23.4694C24.3722 24.0012 23.7374 24.6526 23.2245 25.3959C22.5027 25.2184 21.7636 25.1198 21.0204 25.1021C19.5049 25.1021 18.0515 25.7041 16.9798 26.7757C15.9082 27.8474 15.3062 29.3008 15.3062 30.8163C15.3062 32.3319 15.9082 33.7853 16.9798 34.857C18.0515 35.9286 19.5049 36.5306 21.0204 36.5306C21.7356 36.5116 22.4469 36.4186 23.1429 36.2531C23.9592 39.2898 25.1021 42.9143 26.147 46.3266H33.8531C34.9306 42.9143 36.0408 39.2898 36.8572 36.2531C37.5532 36.4186 38.2645 36.5116 38.9796 36.5306C40.4951 36.5306 41.9486 35.9286 43.0202 34.857C44.0919 33.7853 44.6939 32.3319 44.6939 30.8163C44.6939 29.3008 44.0919 27.8474 43.0202 26.7757C41.9486 25.7041 40.4951 25.1021 38.9796 25.1021ZM21.0204 33.2653C20.6988 33.2653 20.3804 33.202 20.0833 33.0789C19.7861 32.9558 19.5162 32.7754 19.2887 32.548C19.0613 32.3206 18.8809 32.0507 18.7579 31.7535C18.6348 31.4564 18.5715 31.138 18.5715 30.8163C18.5715 30.4947 18.6348 30.1763 18.7579 29.8792C18.8809 29.582 19.0613 29.3121 19.2887 29.0847C19.5162 28.8572 19.7861 28.6769 20.0833 28.5538C20.3804 28.4307 20.6988 28.3674 21.0204 28.3674C21.3434 28.3782 21.6652 28.4109 21.9837 28.4653C21.8936 28.9281 21.8444 29.398 21.8368 29.8694C21.9053 30.971 22.0747 32.064 22.3429 33.1347C21.9073 33.2208 21.4644 33.2645 21.0204 33.2653ZM38.9796 33.2653C38.534 33.2484 38.0911 33.1883 37.6572 33.0857C37.9253 32.0151 38.0947 30.922 38.1633 29.8204C38.1556 29.349 38.1064 28.8792 38.0164 28.4163C38.336 28.3783 38.6578 28.3619 38.9796 28.3674C39.6291 28.3674 40.252 28.6254 40.7113 29.0847C41.1706 29.5439 41.4286 30.1668 41.4286 30.8163C41.4286 31.4659 41.1706 32.0888 40.7113 32.548C40.252 33.0073 39.6291 33.2653 38.9796 33.2653Z" fill="white"/></svg>',
						});
						this.poiCategories.set('129', {
							name: 'kulturna-bastina',
							isParent: true,
							number: 0,
							className: 'kulturna-bastina',
							icon: '<svg class="icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#D95050"/><path d="M29.9996 13.6733C26.9686 13.6733 24.0617 14.8774 21.9184 17.0207C19.7751 19.164 18.571 22.0709 18.571 25.1019H41.4282C41.4282 22.0709 40.2241 19.164 38.0808 17.0207C35.9376 14.8774 33.0307 13.6733 29.9996 13.6733Z" fill="white"/><path d="M44.6935 43.0611H43.0609V41.4284C43.0609 40.9954 42.8888 40.5801 42.5827 40.274C42.2765 39.9678 41.8612 39.7958 41.4282 39.7958V31.6325H43.0609C43.4939 31.6325 43.9091 31.4605 44.2153 31.1543C44.5215 30.8481 44.6935 30.4328 44.6935 29.9998C44.6935 29.5668 44.5215 29.1516 44.2153 28.8454C43.9091 28.5392 43.4939 28.3672 43.0609 28.3672H16.9384C16.5054 28.3672 16.0901 28.5392 15.7839 28.8454C15.4778 29.1516 15.3057 29.5668 15.3057 29.9998C15.3057 30.4328 15.4778 30.8481 15.7839 31.1543C16.0901 31.4605 16.5054 31.6325 16.9384 31.6325H18.5711V39.7958C18.138 39.7958 17.7228 39.9678 17.4166 40.274C17.1104 40.5801 16.9384 40.9954 16.9384 41.4284V43.0611H15.3057C14.8727 43.0611 14.4575 43.2331 14.1513 43.5393C13.8451 43.8454 13.6731 44.2607 13.6731 44.6937C13.6731 45.1267 13.8451 45.542 14.1513 45.8482C14.4575 46.1544 14.8727 46.3264 15.3057 46.3264H44.6935C45.1265 46.3264 45.5418 46.1544 45.848 45.8482C46.1541 45.542 46.3262 45.1267 46.3262 44.6937C46.3262 44.2607 46.1541 43.8454 45.848 43.5393C45.5418 43.2331 45.1265 43.0611 44.6935 43.0611ZM23.469 43.0611V41.4284C23.469 40.9954 23.297 40.5801 22.9908 40.274C22.6846 39.9678 22.2694 39.7958 21.8364 39.7958V31.6325H28.367V39.7958C27.934 39.7958 27.5187 39.9678 27.2125 40.274C26.9063 40.5801 26.7343 40.9954 26.7343 41.4284V43.0611H23.469ZM33.2649 43.0611V41.4284C33.2649 40.9954 33.0929 40.5801 32.7867 40.274C32.4806 39.9678 32.0653 39.7958 31.6323 39.7958V31.6325H38.1629V39.7958C37.7299 39.7958 37.3146 39.9678 37.0084 40.274C36.7022 40.5801 36.5302 40.9954 36.5302 41.4284V43.0611H33.2649Z" fill="white"/></svg>',
						});

						break;
				}
			} else {
				console.log('options is null');
			}

			this.setNumberOfCategories();
			this.initializeFilters();
		},
		setNumberOfCategories() {
			const storeData = useMapStoreData();
			const markersLoop: any = storeData.markers;
			const _this = this;

			// Initialize all category counts to 0
			for (const category of Array.from(this.poiCategories.values())) {
				category.number = 0;
			}

			Object.keys(markersLoop).forEach(function (key) {
				const markerElement = markersLoop[key];
				if (markerElement.properties.categories === null) {
					return;
				}

				// Only count POIs that have the category at the second position (index 1, primary category)
				if (markerElement.properties.categories.length > 1) {
					const secondCategory = markerElement.properties.categories[1];
					if (secondCategory != '') {
						const categoryData: any = _this.poiCategories.get(secondCategory);
						if (categoryData) {
							categoryData.number++;
						}
					}
				}
			});

			// Calculate parent category counts as sum of subcategory counts
			for (const category of Array.from(this.poiCategories.values())) {
				if (category.parentId != '0') {
					const parentCategoryData = _this.poiCategories.get(category.parentId as string);
					if (parentCategoryData) {
						parentCategoryData.number += category.number;
					}
				}
			}

			//Remove categories with count 0
			// for (const category of Array.from(this.poiCategories)) {
			// 	if (category[1].number == 0) {
			// 		const parentId = (this.poiCategories.get(category[0]) as any).parentId;
			// 		if (parentId) {
			// 			const subCategories = this.categoryHierarchy.get(parentId);
			// 			if (subCategories) {
			// 				for (let i = subCategories.length - 1; i >= 0; i--) {
			// 					if (subCategories[i] == category[0]) {
			// 						subCategories.splice(i, 1);
			// 						this.poiCategories.delete(category[0]);
			// 					}
			// 				}
			// 			}
			// 		}
			// 	}
			// }

			//Remove parent categories with count 0
			// for (const category of Array.from(this.poiCategories)) {
			// 	if (category[1].number == 0 && category[1].parentId != '0') {
			// 		this.poiCategories.delete(category[1].parentId as string);
			// 	}
			// }
		},

		setFilterCategories(id: string | Record<string, any>) {
			if (typeof id === 'string') {
				const filterIndex = this.selectedFilters.indexOf(id);

				if (filterIndex === -1) {
					this.selectedFilters.push(id);
				} else {
					this.selectedFilters = this.selectedFilters.filter((filter) => id !== filter);
				}
			}
		},

		toggleMainCategory(id: string) {
			const subcategories = this.categoryHierarchy.get(id);
			if (!subcategories) return;

			// Check how many subcategories from this main category are currently active
			const activeSubcategories = subcategories.filter((val) => this.selectedFilters.includes(val));
			const allSubcategoriesActive = activeSubcategories.length === subcategories.length;

			if (allSubcategoriesActive) {
				// If all subcategories from this main category are active, remove only these subcategories
				this.selectedFilters = this.selectedFilters.filter((val) => !subcategories.includes(val));
			} else {
				// If some or none are active, add all subcategories from this main category
				for (const category of subcategories) {
					if (!this.selectedFilters.includes(category)) {
						this.selectedFilters.push(category);
					}
				}
			}
		},
		initializeFilters() {
			// Initialize with only defaultActiveFiltersParentsId categories
			this.activeFilters = [];
			this.selectedFilters = [];

			// Add all subcategories from defaultActiveFiltersParentsId
			this.defaultActiveFiltersParentsId.forEach((parentId) => {
				const subcategories = this.categoryHierarchy.get(parentId);
				if (subcategories) {
					subcategories.forEach((subcategory) => {
						if (!this.activeFilters.includes(subcategory)) {
							this.activeFilters.push(subcategory);
						}
					});
				}
			});
		},
		resetFilters() {
			// Reset and show all categories
			this.activeFilters = [];
			this.selectedFilters = [];

			// Add all subcategories from all parent categories
			this.categoryHierarchy.forEach((subcategories) => {
				if (subcategories && subcategories.length > 0) {
					subcategories.forEach((subcategory) => {
						if (!this.activeFilters.includes(subcategory)) {
							this.activeFilters.push(subcategory);
						}
					});
				}
			});
		},

		filterMarkersByCategory(poiCategories: Array<string>) {
			// Use selectedFilters if it has elements, otherwise use activeFilters
			const filtersToUse = this.selectedFilters.length > 0 ? this.selectedFilters : this.activeFilters;

			if (filtersToUse.length == 0) {
				return true; // Show all if no filters are active
			}

			// Show POI only if the selected category is at the second position (index 1) in the categories array
			return poiCategories.length > 1 && filtersToUse.includes(poiCategories[1]);
		},

		returnTranslatedKey(key: string) {
			return this.translator(key);
		},
	},
	getters: {
		returnCategoryIcon: (state) => (category: string) => {
			return state.poiCategories.get(category)?.icon;
		},
		returnGradientColor: (state) => (category: string) => {
			const object = state.poiCategories.get(category);
			if (object && object.cssColor) {
				const color = document.documentElement.style.getPropertyValue(object.cssColor);
				return color;
			}
		},
		returnStartStopColor: (state) => (category: string) => {
			const object = state.poiCategories.get(category);
			if (object && object.cssColor) {
				const colorStart = document.documentElement.style.getPropertyValue(object.cssColor + '-start');
				const colorStop = document.documentElement.style.getPropertyValue(object.cssColor + '-stop');
				return [colorStart, colorStop];
			}
		},
		returnTranslatedCardData: (state) => () => {
			const id = useMapStoreData().activePoi;
			const title = state.translator(id + '.title');
			const description = state.translator(id + '.description');
			const addressTitle = state.translator('general.address');
			const openingHoursTitle = state.translator('general.opening_hours');
			const phoneTitle = state.translator('general.phone');
			const emailTitle = state.translator('general.email');
			const websiteTitle = state.translator('general.website');

			return { title, description, addressTitle, openingHoursTitle, phoneTitle, emailTitle, websiteTitle };
		},
	},
});
